import apolloClient from "../apolloClient";
import gql from "graphql-tag";

// GraphQL mutations and queries
const CREATE_APPOINTMENT_BOOKING = gql`
  mutation CreateAppointmentBooking($input: CreateAppointmentBookingInput!) {
    createAppointmentBooking(input: $input) {
      id
      clinicId
      userName
      userPhone
      provinceId
      districtId
      communeId
      address
      petName
      petType
      petBreed
      requireIds
      note
      date
      startTime
      endTime
      status
      isPickup
      appointmentId
      createdAt
      updatedAt
    }
  }
`;

const GET_RESERVED_APPOINTMENTS = gql`
  query GetReservedAppointments(
    $numberPhone: String!
    $clinicId: String!
    $captchaToken: String
  ) {
    getReservedAppointments(
      numberPhone: $numberPhone
      clinicId: $clinicId
      captchaToken: $captchaToken
    ) {
      id
      clinicId
      userName
      userPhone
      provinceId
      districtId
      communeId
      address
      petName
      petType
      petBreed
      requireIds
      note
      date
      startTime
      endTime
      status
      isPickup
      createdAt
      updatedAt
      appointmentId
      fullAddress
      isUpdated
    }
  }
`;

class AppointmentService {
  async createAppointment(input) {
    try {
      const response = await apolloClient.mutate({
        mutation: CREATE_APPOINTMENT_BOOKING,
        variables: { input },
      });
      return response.data.createAppointmentBooking;
    } catch (error) {
      console.error("Error creating appointment:", error);
      throw error;
    }
  }

  async searchAppointment(numberPhone, clinicId, captchaToken) {
    try {
      const response = await apolloClient.query({
        query: GET_RESERVED_APPOINTMENTS,
        variables: {
          numberPhone,
          clinicId,
          captchaToken,
        },
      });
      return response.data.getReservedAppointments;
    } catch (error) {
      console.error("Error searching appointments:", error);
      throw error;
    }
  }
}

export default new AppointmentService();
